<div class="content-wrapper container-xxl p-0">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <!--creatore-->
                <div class="col-md-4 col-12">
                    <label class="font-small-4 font-weight-bold" [ngClass.sm]="'mb-05'">{{ 'CREATED_BY' | translate}}: </label>
                    <a [href]="'/dashboard/user/profile/' + shortlink?.creator?.hash" class="font-medium-1 d-block">
                        {{ shortlink?.creator?.complete_name }}
                    </a>
                </div>
                <!--short link-->
                <div class="col-md-4 col-12">
                    <label class="font-small-4 font-weight-bold">{{ 'SHORTLINK' | translate}}: </label>
                    <p class="font-medium-1" [ngClass.sm]="'text-break-line-1'">{{ environment + '/' + shortlink?.id }}</p>
                </div>
                <!--titolo-->
                <div class="col-md-4 col-12">
                    <label class="font-small-4 font-weight-bold">{{ 'TITLE' | translate}}: </label>
                    <p class="font-medium-1">{{ shortlink?.document?.title }}</p>
                </div>
                <!--data creazione-->
                <div class="col-md-4 col-12">
                    <label class="font-small-4 font-weight-bold" >{{ 'CREATED_THE' | translate}}: </label>
                    <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ _utilService.formatDate(shortlink?.insert_date) }}</p>
                </div>
                <!--utente-->
                <div class="col-md-4 col-12" [ngClass.sm]="'my-05'">
                    <label class="font-small-4 font-weight-bold">{{ 'ALERT.EMPLOYEE' | translate}}: </label>
                    <a [href]="'/dashboard/user/profile/' + shortlink?.user?.hash" *ngIf="shortlink?.user?.complete_name else noOne" [ngClass.xl]="'d-block'" [ngClass.md]="'d-block'" class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'"> {{ shortlink?.user?.complete_name}}</a>
                    <ng-template #noOne>
                        <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ 'ALERT.NOT_FOUND_USER' | translate }}</p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <!--desktop-->
        <div class="card-body p-0" *ngIf="_utilService.isDesktop">
            <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30"
                           [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                           [scrollbarH]="true" [rowHeight]="50" [footerHeight]="50" [limit]="10"
                           [rows]="shortlink?.clicks">
                <!--data-->
                <ngx-datatable-column [name]="'DATE' | translate" [sortable]="false" width="100">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ _utilService.formatDate(row.date) }}</span>
                    </ng-template>
                </ngx-datatable-column>
                <!--ip-->
                <ngx-datatable-column [name]="'IP' | translate" [sortable]="false" width="100">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ row.ip }}</span>
                    </ng-template>
                </ngx-datatable-column>
                <!--informazioni dispositivo-->
                <ngx-datatable-column [name]="'USER_AGENT' | translate" [sortable]="false" width="300">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <span class="line-height-1">{{ row.user_agent }}</span>
                    </ng-template>
                </ngx-datatable-column>
                <!--hash-->
                <ngx-datatable-column [name]="'HASH' | translate" [sortable]="false">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ row.user_hash }}</span>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
        <!--mobile - tablet-->
        <div class="card-body p-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
            <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30"
                           [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                           [scrollbarH]="true" [rowHeight]="180" [footerHeight]="50" [limit]="10"
                           [rows]="shortlink?.clicks">
                <!--data-->
                <ngx-datatable-column [name]="'DATE' | translate" [sortable]="false">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <div class="row">
                            <div class="col-12">
                                <span>{{ _utilService.formatDate(row.date) }}</span>
                            </div>
                            <div class="col-12">
                                <span class="font-weight-bold pr-05">{{ 'IP' | translate }}: </span>
                                <span>{{ row.ip }}</span>
                            </div>
                            <div class="col-12 line-height-1">
                                <span class="font-weight-bold pr-05">{{ 'USER_AGENT' | translate }}: </span>
                                <span>{{ row.user_agent }}</span>
                            </div>
                            <div class="col-12">
                                <span class="font-weight-bold pr-05">{{ 'HASH' | translate }}: </span>
                                <span>{{ row.user_hash }}</span>
                            </div>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    </div>
</div>
